import { useChartUsery } from './hooks'
import { useStatsPermission } from 'app/webview/pages/stats_profile/lib/hooks'
import { StatsProfileBox } from '../../../shared/stats_profile_box'
import { ReaderInsight } from '../../../shared/ReaderInsight'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { getName } from 'utils'
import capitalize from 'lodash/capitalize'
import { RatingComparisonContent } from './RatingComparisonContent'
import { useState } from 'react'
import { analytics } from 'segment_analytics'

export const RatingComparison = () => {
  const [shouldFetch, setShouldFetch] = useState(false)
  const query = useChartUsery({ enabled: shouldFetch })
  const [yearStatus, stats, isSelfView] = useStats((s) => [
    s.yearStatus,
    s.stats,
    s.isSelfView,
  ])
  const { isStatsOwner, isPlusUser, isAndroid } = useStatsPermission()
  const zeroState = !query.data?.pages?.[0]?.data?.results?.length
  const id = 'rating-comparison'
  const statsUserName = getName(stats?.user?.display_name)?.first
  const firstName = statsUserName ? `${capitalize(statsUserName)}'s` : ''

  if (!isPlusUser || isAndroid) return null

  const queryLoaded = shouldFetch && !query.isIdle && query.isFetched

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      onViewed={() => !shouldFetch && setShouldFetch(true)}
      text={{
        top: 'The community rating vs.',
        main: `${isSelfView ? 'Your' : firstName} rating`,
        unit: '',
        infoText: (
          <>
            <b>How do I add a star rating to a book I read?</b>
            <br />
            Go to your Finished list and tap the “Add” button superimposed on
            the book cover.
            <br />
            <br />
            <b>How do I edit a star rating?</b>
            <br />
            Go to your Finished list and tap the star rating superimposed on the
            book cover. After your review loads, tap the “...” in the upper
            right hand corner of your review to edit!
          </>
        ),
      }}
      textAnim={{
        trigger: 'data',
        loaded: queryLoaded,
      }}
      footer={
        queryLoaded && isStatsOwner && zeroState && yearStatus === 'current' ? (
          <ReaderInsight
            data-testid={`reader-insight-${id}`}
            label="How to get started"
            text="Once you rate and review books in your Finished list for this year, we’ll update this chart."
          />
        ) : null
      }
      screenshot={{
        enabled: false,
        component: <RatingComparisonContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'rating_comparison' }),
      }}
    >
      <RatingComparisonContent
        loaded={query.isSuccess}
        onScrollEnd={() => query.hasNextPage && query.fetchNextPage()}
        isFetching={query.isFetchingNextPage}
        isSuccess={!query.isFetching && query.isSuccess}
      />
    </StatsProfileBox>
  )
}
